import { IntakeFormStep } from 'reducers/intakeForm/IntakeFormState';
import { Action } from 'redux';
import { Customer } from 'types/Customer';
import { SavePet } from 'types/Pet';

export const INTAKE_FORM_RESET = 'intake_form/reset';
export const INTAKE_FORM_ERROR = 'intake_form/error';
export const INTAKE_FORM_SET_LOADING = 'intake_form/set_loading';

// Step
export const INTAKE_FORM_SET_STEP = 'intake_form/set_step';

// Customer
export const INTAKE_FORM_SET_CUSTOMER = 'intake_form/set_customer';

// Pet
export const INTAKE_FORM_ADD_PET = 'intake_form/add_pet';
export const INTAKE_FORM_UPDATE_PET = 'intake_form/update_pet';
export const INTAKE_FORM_SET_PETS = 'intake_form/set_pets';

interface IntakeFormResetAction extends Action<typeof INTAKE_FORM_RESET> {}

interface IntakeFormErrorAction extends Action<typeof INTAKE_FORM_ERROR> {}

interface IntakeFormSetLoadingAction extends Action<typeof INTAKE_FORM_SET_LOADING> {
    payload: {
        loading: boolean;
    };
}

interface IntakeFormSetStepAction extends Action<typeof INTAKE_FORM_SET_STEP> {
    payload: {
        step: IntakeFormStep;
    };
}

interface IntakeFormSetCustomerAction extends Action<typeof INTAKE_FORM_SET_CUSTOMER> {
    payload: {
        customer: Customer;
    };
}

interface IntakeFormAddPetAction extends Action<typeof INTAKE_FORM_ADD_PET> {
    payload: {
        pet: SavePet;
    };
}

interface IntakeFormUpdatePetAction extends Action<typeof INTAKE_FORM_UPDATE_PET> {
    payload: {
        pet: SavePet;
    };
}

interface IntakeFormSetPetsAction extends Action<typeof INTAKE_FORM_SET_PETS> {
    payload: {
        pets: Array<SavePet>;
    };
}

export type IntakeFormAction =
    | IntakeFormResetAction
    | IntakeFormErrorAction
    | IntakeFormSetLoadingAction
    | IntakeFormSetStepAction
    | IntakeFormSetCustomerAction
    | IntakeFormAddPetAction
    | IntakeFormUpdatePetAction
    | IntakeFormSetPetsAction;
